<div
    (click)="mostarMenu()"
    id="entidades"
    [@openClose]="showSevicios ? 'open' : 'closed'"
    class="content-servicios-entidades" 
    (mouseover)="eventoOver($event)" (mouseout)="eventoOver($event)">
    <div class="icono-museo">
        <img width="24px" height="20px" src="https://govco-prod-webutils.s3.amazonaws.com/uploads/2021-06-08/223edac2-e696-46a2-a638-612876fd5ac8-Icon%20map-museum.svg" alt="">
    </div>
    <h2>SERVICIOS PARA ENTIDADES</h2>
    <div class="content-list">
        <ul>
            <li>
                <a id="biblioteca" [href]="urlBiblioteca" target="_blank">Biblioteca</a>
            </li>
            <li>
                <a id="c-herramientas"  [href]="urlCajaHerramientas" target="_blank"  >Caja de herramientas</a>
            </li>
            <li>
                <a id="plan-integracion" appValidarUrl  [href]="urlPlanIntegracion"  target="_blank" >Plan de integración</a>
            </li>
            <li>
                <a id="territorial" appValidarUrl  href="https://home.micolombiadigital.gov.co/territorial/"  target="_blank" >GOV.CO/Territorial</a>
            </li>
        </ul>
    </div>
    <div class="content-tooltip" 
        *ngIf="enableToolTip"
        [@openCloseToolTip]="showToolTip ? 'open' : 'closed'"
        (@openCloseToolTip.done)="onAnimationEvent($event)">
        <div class="content-text-shadow"></div>
        <div class="content-arrow"></div>
        <div class="content-text">
            <p>Conoce todos los Recursos y herramientas para entidades</p>
        </div>
    </div>
</div>
